import declare from "dojo/_base/declare";
import xml from "csi/xml";
import EditController from "csi/action/EditController";


const EditCopyTemplate = declare(EditController, {

	toWriter: function() {
		const fd = this.m_formData;
		const fields = fd.getFields().filter((f) => f.m_rca?.dependsOn);
		const cn = this.m_writer.changeNode(this.m_urlNode);
		fields.forEach((field) => {
			const dependsOnField = "_".concat(field.m_rca?.dependsOn);
			const value = fd.getFieldValue(dependsOnField, true);
			cn.changeAttribute(dependsOnField, xml.ATTR_ENUM, value);
		});

		return this.inherited(arguments);
	},
});

export = EditCopyTemplate;